<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('chargeTravailTech.popUpAffecter.title') }}
          </h1>
          <p class="has-text-default mgt-5">
            {{ $t('chargeTravailTech.popUpAffecter.sousTitle') }}
          </p>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="columns is-multiline">
        <b-field class="column is-6 mgb-0 obligatoire"
                 :label="$t('chargeTravailTech.popUpAffecter.technicien')">
          <b-select v-model="technicienId"
                    expanded>
            <option v-for="technicien in techniciens"
                    :key="technicien.id"
                    :value="technicien.id">
              {{ technicien.nomCommercial }}
            </option>
          </b-select>
        </b-field>
        <b-field class="column is-6 mgb-0"
                 :label="$t('chargeTravailTech.popUpAffecter.datePlanification')">
          <b-datepicker show-week-number
                        v-model="date"
                        icon="calendar-today"
                        nearby-selectable-month-days
                        editable>
          </b-datepicker>
        </b-field>
      </div>
      <footer class="mgt-40px">
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$emit('close')">
              {{ $t('general.button.cancel') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction" @click="affecter()">
            <a class="button is-addOrEdit">
              {{ $t('chargeTravailTech.popUpAffecter.actions.affecter') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { getAll as getAllTiers } from '@/api/tiers';
import {
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_TECHNICIEN,
} from '@/configuration/tiers/tiersConf';
import messageErreur from '@/services/general/messageErreur';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    infoBaseForAffectation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      techniciens: [],
      technicienId: null,
      date: null,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    affecter() {
      this.$emit('affectation', {
        technicienId: this.technicienId,
        date: this.date,
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.techniciens = (await getAllTiers({
        query: {
          type: TIERS_TYPE_FOURNISSEUR,
          archive: false,
          sousType: [TIERS_SOUS_TYPE_TECHNICIEN],
          societeId: this.societeActiveId,
        },
        limit: NO_PAGINATION,
      })).data.result.items;
      this.technicienId = this.infoBaseForAffectation.technicienId;
      this.date = this.infoBaseForAffectation.date
        ? new Date(this.infoBaseForAffectation.date) : null;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
